module.exports = {"sys_info":"Información Sistema","name":"Nombre","type_invoice":"Tipo Factura","app_info":"Información Aplicación","app_version":"Versión de la Aplicación","system_energetic_control":"Sistema Control Energético"}


//////////////////
// WEBPACK FOOTER
// ./src/translates/es/InfoApp.json
// module id = 603
// module chunks = 1